if (!customElements.get('sticky-atc-bar')) {
  customElements.define(
    'sticky-atc-bar',
    class StickyAtcBar extends HTMLElement {
      constructor() {
        super();
        document.body.classList.add('sticky-atc-bar-enabled');

        this.selectors = {
          variantIdSelect: '[name="id"]',
        };
      }

      connectedCallback() {
        this.productFormActions = document.querySelector('.main-product-form');
        this.mainProductInfo = document.querySelector('product-info');
        this.container = this.closest('.sticky-atc-bar');
        // Products listed in Theme settings > Product page > Badges read as sold out on every
        // variant, so no variant change may re-enable the button.
        this.forceSoldOut = this.dataset.forceSoldout === 'true';

        this.variantData = this.getVariantData();

        this.init();
        this.addEventListener('change', (event) => {
          this.mainVariantSelects = this.mainProductInfo && this.mainProductInfo.querySelector('variant-selects');
          const variantSelect =
            event && event.target && event.target.matches(this.selectors.variantIdSelect)
              ? event.target
              : this.querySelector(this.selectors.variantIdSelect);
          if (!variantSelect) return;
          const selectedVariantId = variantSelect.value;
          this.currentVariant = this.variantData.find((variant) => variant.id === Number(selectedVariantId));

          if (this.mainVariantSelects) {
            Array.from(this.mainVariantSelects.querySelectorAll('select, fieldset'), (element, index) => {
              const variantOptionVal = this.currentVariant.options[index];

              switch (element.tagName) {
                case 'SELECT':
                  element.value = variantOptionVal;
                  break;
                case 'FIELDSET':
                  Array.from(element.querySelectorAll('input')).forEach((radio) => {
                    if (radio.value === variantOptionVal) {
                      radio.checked = true;
                    }
                  });
                  break;
              }
            });
            this.mainVariantSelects.dispatchEvent(new Event('change'));
          }

          this.updatePrice();
          this.updateVariantTitle();
          this.updateButton(true, '', false);
          if (!this.currentVariant) {
            this.updateButton(true, '', true);
          } else {
            this.updateButton(this.forceSoldOut || !this.currentVariant.available, FoxTheme.variantStrings.soldOut);
          }
        });
      }

      getVariantData() {
        this.variantData =
          this.variantData || JSON.parse(this.container.querySelector('[type="application/json"]').textContent);
        return this.variantData;
      }

      init() {
        if (!this.productFormActions) {
          this.container.classList.add('sticky-atc-bar--show');
          return;
        }
        this.productId = this.dataset.productId;

        const mql = window.matchMedia(FoxTheme.config.mediaQueryMobile);
        mql.onchange = this.checkDevice.bind(this);
        this.checkDevice();

        const rootMargin = `-80px 0px 0px 0px`;
        this.observer = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              const method = entry.intersectionRatio !== 1 ? 'add' : 'remove';
              this.container.classList[method]('sticky-atc-bar--show');
            });
          },
          { threshold: 1, rootMargin }
        );
        this.setObserveTarget();
        this.syncWithMainProductForm();
      }

      updateVariantTitle() {
        const titles = this.querySelectorAll('.sticky-atc-bar__variant-title');
        if (!titles.length) return;
        const text = this.currentVariant ? this.currentVariant.title : '';
        titles.forEach((title) => {
          title.textContent = text;
        });
      }

      setObserveTarget() {
        this.observer.observe(this.productFormActions);
        this.observeTarget = this.productFormActions;
      }

      checkDevice(e) {
        document.documentElement.style.setProperty('--sticky-atc-bar-height', this.clientHeight + 'px');
      }

      updateButton(disable = true, text, modifyClass = true) {
        const productForm = this.querySelector('#product-form-sticky-atc-bar');
        if (!productForm) return;

        const addButton = productForm.querySelector('[name="add"]');
        if (!addButton) return;

        const addButtonText = addButton.querySelector('span');
        if (disable) {
          addButton.setAttribute('disabled', 'disabled');
          if (text) addButtonText.textContent = text;
        } else {
          addButton.removeAttribute('disabled');
          addButtonText.textContent = FoxTheme.variantStrings.addToCart;
        }
      }

      updatePrice() {
        const classes = {
          onSale: 'f-price--on-sale',
          soldOut: 'f-price--sold-out',
        };
        const moneyFormat = FoxTheme.settings.moneyFormat;
        const { compare_at_price, price, unit_price_measurement } = this.currentVariant;
        const priceWrappers = this.querySelectorAll('.f-price');

        priceWrappers.forEach((priceWrapper) => {
          if (!priceWrapper) return;

          const salePrice = priceWrapper.querySelector('.f-price-item--sale');
          const compareAtPrice = priceWrapper.querySelectorAll('.f-price-item--regular');
          const unitPriceWrapper = priceWrapper.querySelector('.f-price__unit-wrapper');
          const unitPrice = unitPriceWrapper && unitPriceWrapper.querySelector('.f-price__unit');

          // On sale.
          if (compare_at_price && compare_at_price > price) {
            priceWrapper.classList.add(classes.onSale);
          } else {
            priceWrapper.classList.remove(classes.onSale);
          }

          // Sold out.
          if (!this.currentVariant.available) {
            priceWrapper.classList.add(classes.soldOut);
          } else {
            priceWrapper.classList.remove(classes.soldOut);
          }

          if (salePrice) salePrice.innerHTML = FoxTheme.Currency.formatMoney(price, moneyFormat);

          if (compareAtPrice && compareAtPrice.length && compare_at_price > price) {
            compareAtPrice.forEach(
              (item) => (item.innerHTML = FoxTheme.Currency.formatMoney(compare_at_price, moneyFormat))
            );
          } else if (compareAtPrice && compareAtPrice.length) {
            compareAtPrice.forEach((item) => (item.innerHTML = FoxTheme.Currency.formatMoney(price, moneyFormat)));
          }

          if (unitPriceWrapper && unitPrice) {
            if (unit_price_measurement) {
              unitPriceWrapper.classList.remove('hidden');
              const unitPriceContent = `<span>${FoxTheme.Currency.formatMoney(
                this.currentVariant.unit_price,
                moneyFormat
              )}</span>/<span data-unit-price-base-unit>${this._getBaseUnit()}</span>`;
              unitPrice.innerHTML = unitPriceContent;
            } else {
              unitPriceWrapper.classList.add('hidden');
            }
          }
        });
      }

      syncWithMainProductForm() {
        FoxTheme.pubsub.subscribe(FoxTheme.pubsub.PUB_SUB_EVENTS.variantChange, (event) => {
          const isMainProduct = event.data.sectionId === this.mainProductInfo.dataset.section;
          if (!isMainProduct) return;
          const variant = event.data.variant;
          const variantInputs = this.querySelectorAll('[name="id"]');

          this.currentVariant = variant;
          variantInputs.forEach((input) => {
            input.value = variant.id;
          });
          this.updatePrice();
          this.updateVariantTitle();
          this.updateButton(true, '', false);
          if (!variant) {
            this.updateButton(true, '', true);
          } else {
            this.updateButton(this.forceSoldOut || !variant.available, FoxTheme.variantStrings.soldOut);
          }
        });
      }
    }
  );
}

// Banner text rotation
document.addEventListener('DOMContentLoaded', function() {
  const bannerSlider = document.querySelector('.sticky-atc-bar__banner-slider');
  if (!bannerSlider) return;

  const autoplay = bannerSlider.dataset.autoplay === 'true';
  const interval = parseInt(bannerSlider.dataset.interval) * 1000 || 4000;
  const bannerTexts = bannerSlider.querySelectorAll('.sticky-atc-bar__banner-text');
  
  if (bannerTexts.length <= 1 || !autoplay) return;

  let currentIndex = 0;

  function rotateBanner() {
    // Add exit class to current text (moves up)
    bannerTexts[currentIndex].classList.add('exit');
    bannerTexts[currentIndex].classList.remove('active');
    
    // Move to next index
    currentIndex = (currentIndex + 1) % bannerTexts.length;
    
    // Add active class to next text (comes from below)
    bannerTexts[currentIndex].classList.remove('exit');
    bannerTexts[currentIndex].classList.add('active');
  }

  setInterval(rotateBanner, interval);
});
